import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AgricultureMapConstants } from 'src/app/main/constants/dims-map-constants';
import { isEmptyField } from 'src/app/main/shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SeamlessTempDataService {
  sourceSelection: any;
  lstTimeStampList: any[] = [];

  constructor(private http: HttpClient) { }

  getTemperatureForecastData(postData: any) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'weatherForecast/getTableData'
    return this.http.post<any>(url, postData)
  }

  getHeirarchy(postData: any) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + "locations/heirarchy";
    return this.http.post<any>(url, postData)
  }

  getTemperatureForecastChartData(postData: any) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + "weatherForecast/getChartData";
    return this.http.post<any>(url, postData)
  }

  getForecastFileTimeStamp(primarySource: any, secondarySource: any) {
    let url = ProjConstants.API_URL + ProjConstants.API_MAPPING['FORECASTFILES'] + '/' + primarySource + "/" + secondarySource;
    let promise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe((data: any) => {
        let max = data[primarySource];
        for (let source in data) {
          if (max == undefined || Number(data[source]) > max) {
            max = Number(data[source])
          }
        }
        resolve(max.toString())
      })
    })
    return promise
  }
  getDateObj(isDailyOrWeekly: boolean, isMODIS: boolean, isISO: boolean, yyyymmdd: string, timePeriod: string) {
    let obj: any;
    if (isDailyOrWeekly) {
      if (isMODIS) {
        const yr = Number(yyyymmdd.substring(0, 4));
        const mo = Number(yyyymmdd.substring(4, 6)) - 1;
        const dy = Number(yyyymmdd.substring(6, 8));
        obj = { millis: new Date(yr, mo, dy).getTime() };
      } else {
        obj = { millis: yyyymmdd };
      }
    } else {
      if (isISO) {
        const d = new Date(timePeriod);
        const cleanTs =
          d.getUTCFullYear().toString() +
          ('0' + (d.getUTCMonth() + 1)).slice(-2) +
          ('0' + d.getUTCDate()).slice(-2) +
          ('0' + d.getUTCHours()).slice(-2) +
          ('0' + d.getUTCMinutes()).slice(-2);
        obj = this.convertToDateTime(cleanTs);
      } else {
        obj = this.convertToDateTime(timePeriod);
      }
    }
    return obj;
  }
  get24HrsTimeStamps() {
    // ---------------33435 IMD Block---------------
    let hoursIncrement = 0;
    let startHour = 8;
    // if (source == 'IMD') {
    //   hoursIncrement = ProjConstants.SOURCE_TIMESTAMP_DIFF.IMD;
    //   startHour = 8;
    // }
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(startHour, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blockIndex = Math.floor((refTs - dayStartTs) / 10800000);
    let startTimestamp = this.getCurrentBlockTs(dayStartTs)

    const blocks: any = {};
    for (let i = 0; i < 8; i++) {
      blocks[i] = {};
      // blocks[i]['timeStamp'] = dayStartTs + ((i + blockIndex) * 10800000);
      blocks[i]['timeStamp'] = startTimestamp + ((i * 10800000));
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['toolTip'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLineName']['label'] = this.convertTimestampToBlockValue(blocks[i]['timeStamp']);
      blocks[i]['leftSideName'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLinePos'] = i;
    }
    let index = this.getCurrentBlockIndex(blocks)
    // console.log("BLOCKS::",blocks,index);
    blocks[8] = {};
    blocks[8]['timeStamp'] = blocks[index]['timeStamp'];
    blocks[8]['timeLineName'] = {};
    blocks[8]['timeLineName']['toolTip'] = this.convertTimestampToBlockValue(blocks[index]['timeStamp']) + '-' + this.convertTimestampToBlockValue(blocks[index]['timeStamp']);
    blocks[8]['timeLineName']['label'] = '24hr';
    blocks[8]['leftSideName'] = '24hr';
    blocks[8]['timeLinePos'] = 8;
    return blocks;
  }

  get10DaysTimeStamps(source: any, timestamp: any) {
    let hoursIncrement = 0;
    let startHour;
    if (timestamp.endsWith('00')) {
      startHour = 8
    } else {
      startHour = 20
    }
    // if (source == 'IMD') {
    //   hoursIncrement = ProjConstants.SOURCE_TIMESTAMP_DIFF.IMD;
    //   startHour = 8;
    // }
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(startHour, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blocks: any = {};
    for (let i = 0; i < 7; i++) {
      blocks[i] = {};
      // blocks[i]['timeStamp'] = dayStartTs + ((i) * 86400000);
      blocks[i]['timeStamp'] = dayStartTs + ((i) * 86400000) - hoursIncrement;
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['label'] = this.convetTimeStampToDay(blocks[i]['timeStamp'] + hoursIncrement);
      blocks[i]['timeLineName']['toolTip'] = source == 'IMD' ? '8:30 AM - 8:30 AM' : '5:30 AM - 5:30 AM';
      blocks[i]['leftSideName'] = this.convetTimeStampToDay(blocks[i]['timeStamp'] + hoursIncrement);
      blocks[i]['timeLinePos'] = i;
    }
    return blocks;
  }

  getCurrentBlockTs(dayStartTs: any) {
    let currentTs = new Date().getTime()
    let blockTs = dayStartTs;
    let timeStamp;
    for (let i = 0; i < 8; i++) {
      if (blockTs <= currentTs) {
        timeStamp = blockTs;
      } else {
        break;
      }
      blockTs = blockTs + 10800000;
    }
    return timeStamp

  }

  convertTimestampToFullBlockValue(ts: any) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startamPm = 'A.M';
    if (starthours > 12) {
      starthours = starthours - 12;
      startamPm = 'P.M';
    }
    let endhours = new Date(ts + ProjConstants.MILLS_IN_3HOURS).getHours();
    const endminutes = new Date(ts + ProjConstants.MILLS_IN_3HOURS).getMinutes();
    let endamPm = 'A.M';
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    return starthours.toString() + ':' + startminutes.toString() + ' ' + startamPm + ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;
  }

  convertTimestampToBlockValue(ts: any) {
    ts = Number(ts);
    let hours = new Date(ts).getHours();
    const minutes = new Date(ts).getMinutes();
    let amPm = 'A.M';
    if (hours > 12) {
      hours = hours - 12;
      amPm = 'P.M';
    }
    return hours.toString() + ':' + minutes.toString() + ' ' + amPm;
  }

  getCurrentBlockIndex(blocks: any) {
    const currentTime = new Date().getTime();
    let currentBlockIndex: any = 0; // Default value if not found

    for (const index in blocks) {
      const blockStartTime = blocks[index].timeStamp;
      const blockEndTime = blockStartTime + 3 * 60 * 60 * 1000; // 3 hours in milliseconds

      if (currentTime >= blockStartTime && currentTime < blockEndTime) {
        currentBlockIndex = index;
        break;
      }
    }

    return currentBlockIndex;
  }

  convetTimeStampToDay(ts: any) {
    const date = new Date(Number(ts));
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;   // e.g. 02/11/2026
  }

  getHeatMap(url: any) {
    let dataPromise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        data => {
          let obj = this.setMapData(data);
          resolve(obj);
        });
    });
    return dataPromise;
  }

  setMapData(data: any) {
    let obj: any = {};
    let imageUrl = {};
    let imageBounds = [];
    for (let block of Object.keys(data)) {
      for (let property of Object.keys(data[block])) {
        imageUrl = data[block]['heatMapImage'];
        let latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['southWest']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['southWest']['longitude']);
        imageBounds.push(latlongs);
        latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['northEast']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['northEast']['longitude']);
        imageBounds.push(latlongs);
      }
      obj['url'] = imageUrl;
      obj['bounds'] = imageBounds;
    }
    return obj;
  }

  getImageBounds(imageBounds: any) {
    const anchors = [];
    anchors.push([imageBounds[1][0], imageBounds[0][1]]);
    anchors.push([imageBounds[1][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[0][1]]);
    return anchors;
  }

  deepClone(object: any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj: any = {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }

  getUpdatePostData(queryParams: any) {
    if (queryParams.forecastLength == 'seasonal') {
      this.sourceSelection = 'ECMWF';
    } else {
      this.sourceSelection = queryParams['source'] == 'IMD_SHORT_RANGE' ? 'IMD_LONG_RANGE' : queryParams['source'];
    }
    let postData: any
    let allLocations = queryParams.location.split('&')
    let stateUUID;
    if (queryParams.locType == 'DISTRICT') {
      stateUUID = allLocations[1].split('##')[1]
    }
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(queryParams.locType) + 1];
    let firstLevel: any = hie[hie.indexOf(queryParams.locType) - 1];
    const refDate = new Date();
    refDate.setHours(8, 30, 0, 0);
    let refTs = refDate.getTime();
    if (queryParams.locType == 'COUNTRY' || queryParams.locType == 'STATE') {
      postData = {
        "primarySource": queryParams.forecastLength == 'seasonal' ? 'ECMWF_EXT_MONTHLY_TEMP' : queryParams['source'],
        "secondarySource": queryParams.forecastLength == 'seasonal' ? 'ECMWF' : this.sourceSelection,
        "sUUID": queryParams.pUUID,
        "component": "TEMPERATURE",
        "pUUID": queryParams.pUUID,
        "pType": queryParams.locType,
        "forecastLength": queryParams.forecastLength == 'seasonal' ? 'ecmwf_ext_monthly_temp' : queryParams.forecastLength == 'seamless' ? '24' : queryParams.forecastLength,
        "view": "Admin",
        "cType": currentLevel,
        "refTs": refTs
      }
    } else {
      postData = {
        "primarySource": queryParams.forecastLength == 'seasonal' ? 'ECMWF_EXT_MONTHLY_TEMP' : queryParams['source'],
        "secondarySource": queryParams.forecastLength == 'seasonal' ? 'ECMWF' : this.sourceSelection,
        "sUUID": stateUUID,
        "component": "TEMPERATURE",
        "pUUID": queryParams.pUUID,
        "pType": queryParams.locType,
        "forecastLength": queryParams.forecastLength == 'seasonal' ? 'ecmwf_ext_monthly_temp' : queryParams.forecastLength == 'seamless' ? '24' : queryParams.forecastLength,
        "view": "Admin",
        "cType": currentLevel,
        "refTs": refTs,
      }
    }
    return postData;
  }

  getChartData(formattedChartData: any[], params: any): any {
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(params.locType) - 1];
    let firstLevel: any = hie[hie.indexOf(params.locType) + 1];
    let locType = firstLevel.toLowerCase().split(' ').map((word: any) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

    if (!formattedChartData || formattedChartData.length === 0) {
      return {}; // return empty if no data
    }
    const timestamps = Object.keys(formattedChartData[0]).filter(key => key !== "Rainfall Band").sort((a, b) => Number(a) - Number(b));
    let categories: any;
    if (params.forecastLength == 'seamless') {
      categories = timestamps.map(ts => {
        if (ts === "24hr") {
          return "24hr";
        } else {
          const date = new Date(Number(ts));
          const hours = date.getHours().toString().padStart(2, '0');
          const minutes = date.getMinutes().toString().padStart(2, '0');
          return `${hours}:${minutes}`;
        }
      });
    } else if (params.forecastLength == '10') {
      categories = timestamps.map(ts => {
        const date = new Date(Number(ts));
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      });
    } else if (params.forecastLength == 'seasonal') {
      categories = timestamps.map(ts => {
        const tsStr = ts.toString();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        if (tsStr.length === 6) { // YYYYMM
          const year = tsStr.substring(0, 4);
          const month = tsStr.substring(4, 6);
          return monthNames[Number(month) - 1] + ' ' + year;
        } else if (tsStr.length >= 10) { // Milliseconds
          const date = new Date(Number(ts));
          return monthNames[date.getMonth()] + ' ' + date.getFullYear();
        }
        return tsStr;
      });
    }

    const colorMap: { [key: string]: string } = {
      "<0": "#00167B",
      "0-5": "#001B95",
      "5-10": "#0C41BB",
      "10-15": "#1265A9",
      "15-20": "#188E93",
      "20-25": "#81BA63",
      "25-28": "#CCC24F",
      "28-31": "#FFBB38",
      "31-34": "#FF9E20",
      "34-37": "#FF800E",
      "37-40": "#FD5F0D",
      "40-43": "#FF3F0A",
      "43-46": "#DF2108",
      ">=46": "#AD1919"
    };
    const isSeasonal = params.forecastLength == 'seasonal';
    const selectedColorMap = isSeasonal ? this.seasonalTempColorMap : colorMap;
    const chartRows = isSeasonal ? [...formattedChartData].sort((a, b) => {
      const aIndex = this.seasonalTempBandOrder.indexOf(a["Rainfall Band"]);
      const bIndex = this.seasonalTempBandOrder.indexOf(b["Rainfall Band"]);
      const aOrder = aIndex == -1 ? Number.MAX_SAFE_INTEGER : aIndex;
      const bOrder = bIndex == -1 ? Number.MAX_SAFE_INTEGER : bIndex;
      return aOrder - bOrder;
    }) : formattedChartData;

    // Dynamically generate series for each Rainfall Band
    const series = chartRows.map(item => ({
      name: item["Rainfall Band"],
      type: 'column',
      data: timestamps.map(ts => item[ts] || 0),
      color: selectedColorMap[item["Rainfall Band"]] || "#808080" // default color if not found
    }));

    const chartOptions = {
      chart: {
        type: 'column',
        backgroundColor: '#000000'
      },
      title: {
        text: '',
        style: {
          color: '#9aa2a7ff',
          fontFamily: 'poppins, sans-serif',
        }
      },
      xAxis: {
        categories: categories,
        labels: {
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: `No of ${locType}`,
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        labels: {
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        gridLineColor: '#808080'
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemMarginTop: 4,
        itemMarginBottom: 4,
        symbolRadius: 0,
        itemStyle: {
          color: '#9aa2a7ff',
          fontFamily: 'poppins, sans-serif',
          fontSize: '12px',
          fontWeight: 'normal'
        }
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true
          }
        }
      },
      series: series,
      credits: {
        enabled: false
      }
    };

    return chartOptions;
  }

  setChartData(data: any, ProjConstants: any) {
    const keys = Object.keys(data);
    const formattedChartData = [];
    for (const key of keys) {
      const obj: any = {};
      for (const item of Object.keys(data[key])) {

        if (item == '6hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        } else if (item == '24hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj['24hr'] = data[key][item][timestamp];
          }
        } else {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        }
      }
      obj[ProjConstants.CHART_DATA_COLUMNS['RAINFALL']] = key;
      formattedChartData.push(obj);
    }
    return formattedChartData;
  }

  getLSTTableData(postData: any) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'surfaceTemp/getSurfaceTempAggregatedData'
    const resolvedDate = postData && (postData.date || postData.Date) ? (postData.date || postData.Date) : this.getCurrentDateYYYYMMDD();
    const payload = { ...postData, date: resolvedDate };
    delete payload.Date;
    return this.http.post<any>(url, payload)
  }

  getLSTDailyData(postData: any, queryParams: any) {
    const apiEndPoint: any = queryParams['forecastLength'] == '-7W' ? 'surfaceTemp/getSurfaceTempWeeklyAggregatedData' : 'surfaceTemp/getSurfaceTempDailyAggregatedData'
    const url = environment.url.HEATWAVE_STAGING_API_URL + apiEndPoint;
    return this.http.post<any>(url, postData);
  }

  getIMDWeeklyData(postData: any) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'temperature/getIMDWeeklyData';
    return this.http.post<any>(url, postData);
  }

  getIMDData(postData: any) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'temperature/imdData';
    return this.http.post<any>(url, postData);
  }

  getLSTHeapMaps(date?: any) {
    const resolvedDate = date || this.getCurrentDateYYYYMMDD();
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'surfaceTemp/layerTimeDimensions/' + resolvedDate + '/' + resolvedDate;
    return this.http.get<any>(url)
  }

  getSeasonalHeatMap() {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'weatherForecast/getECMWFExtendedHeatMapsBySourceAndComponent/ECMWF_EXT_MONTHLY_TEMP/ecmwf_ext_monthly_temp'
    return this.http.get<any>(url)
  }

  getLSTHeapMapTimeline(startDate?: string, endDate?: string, queryParams?: any) {
    const payload = {
      source: "EUMETSAT_SURFACE_TEMPERATURE",
      startDate: startDate,
      endDate: endDate,
      timeFormat: "DAILY",
      aggrType: queryParams.aggrType
    };
    const apiEndPoint: any = queryParams['forecastLength'] == '-7W'
      ? 'surfaceTemp/layerTimeDimensions/lst_weekly/lst_weekly'
      : 'surfaceTemp/layerTimeDimensions/lst_daily/lst_daily';
    const url = environment.url.HEATWAVE_STAGING_API_URL + apiEndPoint;
    return this.http.get<any>(url, { params: payload });
  }

  getMODISLSTHeapMapTimeline(queryParams: any) {
    const apiEndPoint: any = queryParams['format'] == 'DAY'
      ? 'surfaceTemp/modisLayerTimeDimensions/modis_lst_day/modis_lst_day'
      : 'surfaceTemp/modisLayerTimeDimensions/modis_lst_night/modis_lst_night';
    const url = environment.url.HEATWAVE_STAGING_API_URL + apiEndPoint;
    return this.http.get<any>(url);
  }

  getCurrentDateYYYYMMDD() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  }

  convertTimestampToFullBlockValue3(ts: any) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startamPm = 'A.M';
    if (starthours > 12) {
      starthours = starthours - 12;
      startamPm = 'P.M';
    }
    let endhours = new Date(ts + ProjConstants.MILLS_IN_10MINS).getHours();
    const endminutes = new Date(ts + ProjConstants.MILLS_IN_10MINS).getMinutes();
    let endamPm = 'A.M';
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    return starthours.toString().padStart(2, '0') + ':' + startminutes.toString().padStart(2, '0') + ' ' + startamPm + ' - ' + endhours.toString().padStart(2, '0') + ':' + endminutes.toString().padStart(2, '0') + ' ' + endamPm;
  }

  convertTimestampToDate(ts: any) {
    ts = Number(ts);
    const date = new Date(ts);

    // Date parts
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    let hours = date.getHours();     // Local time hours
    const minutes = date.getMinutes();

    let amPm = hours >= 12 ? "P.M" : "A.M";

    // Convert to 12-hour format
    hours = hours % 12;
    if (hours === 0) hours = 12;

    // Format with leading zeros
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${day}/${month}/${year} ${formattedHours}:${formattedMinutes} ${amPm}`;
  }

  convertTimestampToDateBlockValue(ts: any) {
    ts = Number(ts);
    const date = new Date(ts);

    // Date parts
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    // Time parts
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const amPm = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours = hours % 12;
    if (hours === 0) hours = 12;

    // if (params.fogView == 'observed') {
    return `${hours}:${minutes} ${amPm}`
    // }
  }

  // getImageBounds(imageBounds) {
  //   const anchors = [];
  //   anchors.push([imageBounds[1][0], imageBounds[0][1]]);
  //   anchors.push([imageBounds[1][0], imageBounds[1][1]]);
  //   anchors.push([imageBounds[0][0], imageBounds[1][1]]);
  //   anchors.push([imageBounds[0][0], imageBounds[0][1]]);
  //   return anchors;
  // }

  getHeatMapImageBounds(heatmapimageBounds: any) {
    let latlongs: any = [];
    let imageBounds: any = []

    latlongs.push(heatmapimageBounds['southWest']['latitude']);
    latlongs.push(heatmapimageBounds['southWest']['longitude']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(heatmapimageBounds['northEast']['latitude']);
    latlongs.push(heatmapimageBounds['northEast']['longitude']);
    imageBounds.push(latlongs);
    return imageBounds;
  }

  formatNumber(value: number): number {
    return Math.abs(value) < 1e-10 ? 0 : value;
  }

  getChartDataForLandingPage(formattedChartData: any[], params: any, seriesColors?: string[]): any {
    if (!formattedChartData || formattedChartData.length === 0) {
      return {};
    }
    const allTimestamps = Object.keys(formattedChartData[0])
      .filter(key => key !== "LocationName")
      .sort((a, b) => Number(a) - Number(b));

    const timestamps = allTimestamps.filter(ts => {
      return formattedChartData.some(item => {
        let val = item[ts];
        return !(val === undefined || val === null || val === 'NA' || val === '');
      });
    });

    const categories = timestamps.map(ts => {
      if (ts === "24hr") {
        return "24hr";
      } else {
        if ((params['forecastLength'] == '-7' && (params['format'] == 'DAILY') || params['format'] == 'DAY' || params['format'] == 'NIGHT') || params['forecastLength'] == '-7W') {
          return this.formatDateToDDMMYYYY(ts, params)
        } else if (params['forecastLength'] == '10') {
          const date = new Date(Number(ts));
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
          // const year = date.getFullYear();
          // return `${day}/${month}/${year}`;
          return `${day}/${month}`;
        } else if (params['forecastLength'] == 'seasonal') {
          const date = this.formatDateToMonthYear(ts)
          return date
        } else {
          const date = new Date(Number(ts));
          const hours = date.getHours().toString().padStart(2, '0');
          const minutes = date.getMinutes().toString().padStart(2, '0');
          return `${hours}:${minutes}`;
        }
      }
    });

    const series = formattedChartData.map((item, index) => ({
      name: item["LocationName"],
      type: 'line',
      data: timestamps.map(ts => {
        let val = item[ts];
        if (val === undefined || val === null || val === 'NA' || val === '') {
          return null;
        }
        return Number(val);
      }),
      color: (seriesColors && seriesColors[index]) || "#ffc107",
      lineWidth: 2,
      marker: {
        enabled: true,
        radius: 3,
        symbol: 'circle'
      }
    }));

    const chartOptions = {
      chart: {
        type: 'line',
        height: 280,
        backgroundColor: '#404040'
      },
      title: {
        text: '',
        style: { color: '#9aa2a7ff', fontFamily: 'poppins, sans-serif' }
      },
      xAxis: {
        categories: categories,
        labels: { style: { color: '#9aa2a7ff', fontFamily: 'poppins, sans-serif' } },
        crosshair: true
      },
      yAxis: {
        title: {
          text: `Temperature (°C)`,
          style: { color: '#9aa2a7ff', fontFamily: 'poppins, sans-serif' }
        },
        labels: { style: { color: '#9aa2a7ff', fontFamily: 'poppins, sans-serif' }, format: '{value}°C' },
        gridLineColor: '#808080'
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemMarginTop: 4,
        itemMarginBottom: 4,
        symbolRadius: 0,
        itemStyle: { color: '#9aa2a7ff', fontFamily: 'poppins, sans-serif', fontSize: '10px', fontWeight: 'normal' }
      },
      tooltip: {
        shared: true,
        backgroundColor: '#1e1e1e',
        borderColor: '#666',
        style: { color: '#fff' },
        pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.1f}°C</b><br/>'
      },
      plotOptions: {
        line: {
          marker: { enabled: true },
          connectNulls: false
        }
      },
      series: series,
      credits: { enabled: false },
      exporting: { enabled: false }
    };

    return chartOptions;
  }

  getDateForSeamless() {
    const today = new Date();
    const y = today.getFullYear();
    const m = ("0" + (today.getMonth() + 1)).slice(-2);
    const d = ("0" + today.getDate()).slice(-2);
    return `${y}${m}${d}`;
  }

  getStartAndEndDatesForWeeklyData(params: any) {
    const toYYYYMMDD = (iso: string) => {
      const d = new Date(iso);
      const y = d.getUTCFullYear();
      const m = ('0' + (d.getUTCMonth() + 1)).slice(-2);
      const day = ('0' + d.getUTCDate()).slice(-2);
      return `${y}${m}${day}`;
    };
    if (params.forecastLength == '-7W') {
      const endDateObj = new Date();
      const startDateObj = new Date();
      startDateObj.setDate(endDateObj.getDate() - (7 * 7)); // 7 weeks back

      return {
        endDate: this.formatDate(endDateObj),
        startDate: this.formatDate(startDateObj)
      };
    }
    const today = new Date();
    if (params.format === 'DAILY') {
      const end = this.formatDate(today);
      const past = new Date();
      past.setDate(past.getDate() - 6);
      const start = this.formatDate(past);
      return { startDate: start, endDate: end }
    }
    else if (params.format === 'DAY' || params.format === 'NIGHT') {
      const toSafeYYYYMMDD = (ts: string) => {
        if (!ts) return '';
        if (ts.includes('T')) {
          const d = new Date(ts);
          return `${d.getUTCFullYear()}${('0' + (d.getUTCMonth() + 1)).slice(-2)}${('0' + d.getUTCDate()).slice(-2)}`;
        }
        return ts.substring(0, 8); // already YYYYMMDD (or YYYYMMDDHHmm)
      };
      const start = toSafeYYYYMMDD(this.lstTimeStampList[0]);
      const end = toSafeYYYYMMDD(this.lstTimeStampList[this.lstTimeStampList.length - 1]);
      return { startDate: start, endDate: end }
    }
    else if (params.format === 'HOURLY') {
      return this.getDateForHourlyData()
    }
  }

  getDateForHourlyData() {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const date = this.formatDate(yesterday);
    return date
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = ("0" + (date.getMonth() + 1)).slice(-2);
    const d = ("0" + date.getDate()).slice(-2);
    return `${y}${m}${d}`;
  }

  getLocationWiseChartTitle(firstLevel: any) {
    return "No of " + firstLevel.toLowerCase().split(" ").map((word: any) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
  }

  formatDateToDDMMYYYY(dateStr: string, params: any): string {
    const str = dateStr.toString();
    if (str.length === 13) {
      const date = new Date(Number(str));
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    if (params['forecastLength'] == '-7W') {
      return this.formatDateRange(dateStr)
    }
    else {
      return `${dateStr.substring(6, 8)}/${dateStr.substring(4, 6)}/${dateStr.substring(0, 4)}`;
    }
  }

  formatDateRange(yyyymmdd: any) {
    const dateStr = yyyymmdd.toString();
    let enddate: any;

    const year = Number(dateStr.substring(0, 4));
    const month = Number(dateStr.substring(4, 6)) - 1;
    const day = Number(dateStr.substring(6, 8));

    const startDate = new Date(year, month, day);
    const currentDate = new Date();

    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);

    if (endDate > currentDate) {
      endDate.setTime(currentDate.getTime());
    }

    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const format = (date: Date) => {
      const m = months[date.getMonth()];
      const d = String(date.getDate()).padStart(2, '0');
      return `${m} ${d}`;
    };

    return `${format(startDate)} - ${format(endDate)}`;
  }

  formatDateToMonthYear(dateStr: any) {
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const label = monthNames[Number(month) - 1] + ' ' + year;
    return label
  }

  getLast7DaysMap() {
    const result: any = {};
    for (let i = 1; i < 8; i++) {
      const date = new Date();
      date.setDate(date.getDate() - i);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const key = `${year}${month}${day}`;        // yyyymmdd
      const value = `${day}/${month}/${year}`;    // dd/mm/yyyy
      result[key] = value;
    }
    return result;
  }

  convertToDateTime(input: string) {
    const year = parseInt(input.slice(0, 4));
    const month = parseInt(input.slice(4, 6)) - 1;
    const day = parseInt(input.slice(6, 8));
    const hour = parseInt(input.slice(8, 10));
    const minute = parseInt(input.slice(10, 12));

    const date = new Date(year, month, day, hour, minute)
    // Parse as UTC
    const utcDate = new Date(Date.UTC(year, month, day, hour, minute));
    return {
      millis: utcDate.getTime(),
    };
  }

  convertListToYYYYMMDDHHMM(timestamps: number[]): string[] {
    if (!timestamps || !timestamps.length) return [];

    return timestamps.map(ts => {
      const date = new Date(Number(ts));

      return (
        date.getUTCFullYear() +
        ('0' + (date.getUTCMonth() + 1)).slice(-2) +
        ('0' + date.getUTCDate()).slice(-2) +
        ('0' + date.getUTCHours()).slice(-2) +
        ('0' + date.getUTCMinutes()).slice(-2)
      );
    });
  }

  formatWeeklyLabel(yyyymmdd: string): string {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const yr = Number(yyyymmdd.substring(0, 4));
    const mo = Number(yyyymmdd.substring(4, 6)) - 1;
    const dy = Number(yyyymmdd.substring(6, 8));

    const startDate = new Date(yr, mo, dy);
    const endDate = new Date(yr, mo, dy);
    endDate.setDate(startDate.getDate() + 6);

    // ✅ Cap end date at today so future dates don't show
    const today = new Date();
    if (endDate > today) endDate.setTime(today.getTime());

    const fmt = (d: Date) =>
      monthNames[d.getMonth()] + ' ' + String(d.getDate()).padStart(2, '0');

    return `${fmt(startDate)} - ${fmt(endDate)}`; // e.g. "Apr 13 - Apr 19"
  }

  seasonalTempColorMap: { [key: string]: string } = {
    "< -2.0°C": "#000099",
    "< -2.0": "#000099",
    "<-2.0": "#000099",
    "<-2°C": "#000099",
    "-2.0 to -1.0°C": "#3355ff",
    "-2 to -1°C": "#3355ff",
    "-1.0 to -0.5°C": "#66aaff",
    "-1 to -0.5°C": "#66aaff",
    "-0.5 to -0.1°C": "#77ffff",
    "-0.1 to 0.1°C": "#ffffff",
    "0.1 to 0.5°C": "#ffee33",
    "0 to 0.5°C": "#ffee33",
    "0.5 to 1.0°C": "#ffaa00",
    "0.5 to 1°C": "#ffaa00",
    "1.0 to 2.0°C": "#ff4400",
    "1 to 2°C": "#ff4400",
    "> 2.0°C": "#cc0022",
    ">2.0°C": "#cc0022",
    ">2°C": "#cc0022"
  }

  seasonalTempBandOrder: string[] = [
    "< -2.0°C",
    "< -2.0",
    "<-2.0",
    "<-2",
    "-2.0 to -1.0",
    "-2 to -1",
    "-1.0 to -0.5",
    "-1 to -0.5",
    "-0.5 to 0.0",
    "-0.5 to 0",
    "No Signal",
    "0.0 to 0.5",
    "0 to 0.5",
    "0.5 to 1.0",
    "0.5 to 1",
    "1.0 to 2.0",
    "1 to 2",
    "> 2.0°C",
    "> 2.0",
    ">2.0",
    ">2"
  ];

}
